import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import api from 'utils/api';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, provider }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await api.delete(`/providers/${provider._id}`);
      onConfirm(); // Notify parent
      onClose(); // Close modal
    } catch (err) {
      console.error('Error deleting Provider:', err);
      alert('خطا در حذف خدمات دهنده');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !provider) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md animate-scale-in">
        {/* Header */}
        <div className="flex items-center gap-3 p-6 border-b border-border">
          <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} className="text-error" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">
              حذف خدمات دهنده
            </h2>
            <p className="text-sm text-muted-foreground">
              این عمل قابل بازگشت نیست
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-foreground mb-4">
            آیا از حذف خدمات دهنده
            <span className="font-semibold"> "{provider?.name}" </span>
            اطمینان دارید؟
          </p>

          <div className="bg-error/5 border border-error/20 rounded-lg p-4 mb-4">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={16} className="text-error mt-0.5" />
              <div className="text-sm text-error">
                <p className="font-medium mb-1">هشدار:</p>
                <ul className="space-y-1 text-xs">
                  <li>• تمام اطلاعات کارمندان این خدمات دهنده حذف خواهد شد</li>
                  <li>• تمام خدمات و نوبت‌های ثبت شده پاک خواهد شد</li>
                  <li>• این عمل قابل بازگشت نیست</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
            disabled={loading}>
            انصراف
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            loading={loading}
            className="flex-1"
            iconName="Trash2"
            iconPosition="right">
            حذف خدمات دهنده
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
